var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/components/Draggable/index.tsx
import { throttle } from "lodash-es";
import React2, {
  createRef
} from "react";

// src/components/Draggable/DraggableCursor.tsx
import React from "react";
import { createGlobalStyle } from "@marvelapp/styled-components";
var DraggableCursor = ({ cursor }) => {
  return cursor && cursor !== "default" ? /* @__PURE__ */ React.createElement(GlobalStyle, {
    cursor
  }) : null;
};
var GlobalStyle = createGlobalStyle`
  ${(p) => p.cursor !== "default" && `
    body {
      cursor: ${p.cursor} !important;

      > * {
        pointer-events: none;
      } 
    } 
  `}
`;

// src/components/Draggable/index.tsx
function toDragData(internalDragData) {
  if (internalDragData === null)
    return null;
  const { dragging, lastX, lastY, originX, originY, x, y } = internalDragData;
  return {
    deltaX: x - lastX,
    deltaY: y - lastY,
    dragging,
    lastX,
    lastY,
    originX,
    originY,
    totalDeltaX: x - originX,
    totalDeltaY: y - originY,
    x,
    y
  };
}
var Draggable = class extends React2.Component {
  constructor(props) {
    super(props);
    this.dragData = null;
    this.isDisabled = () => {
      if (!this.props.disabled)
        return false;
      if (typeof this.props.disabled === "function") {
        return this.props.disabled();
      }
      return this.props.disabled;
    };
    this.onDrag = (event) => {
      const { clientX, clientY } = event;
      if (this.dragData === null) {
        throw new Error("onDrag called without dragData being initialized");
      }
      this.dragData.lastX = this.dragData.x;
      this.dragData.lastY = this.dragData.y;
      this.dragData.x = clientX - this.dragData.offsetX;
      this.dragData.y = clientY - this.dragData.offsetY;
      if (this.props.onDrag) {
        this.props.onDrag(event, toDragData(this.dragData));
      }
      if (typeof this.props.children === "function") {
        this.forceUpdate();
      }
    };
    this.onDragEnd = (event) => {
      var _a;
      const { clientX, clientY } = event;
      this.setState({ dragging: false });
      if (this.dragData === null) {
        throw new Error("onDragEnd called without dragData being initialized");
      }
      this.dragData.dragging = false;
      this.dragData.x = clientX - this.dragData.offsetX;
      this.dragData.y = clientY - this.dragData.offsetY;
      (_a = this.localRef.current) == null ? void 0 : _a.releasePointerCapture(event.pointerId);
      if (this.props.onDragEnd) {
        this.props.onDragEnd(event, toDragData(this.dragData));
      }
      if (typeof this.props.children === "function") {
        this.forceUpdate();
      }
      this.dragData = null;
    };
    this.onDragStart = (event) => {
      var _a;
      (_a = this.localRef.current) == null ? void 0 : _a.setPointerCapture(event.pointerId);
      const { clientX, clientY } = event;
      const eventTarget = event.currentTarget;
      const offsetX = eventTarget.offsetLeft ?? 0;
      const offsetY = eventTarget.offsetTop ?? 0;
      const x = clientX - offsetX;
      const y = clientY - offsetY;
      this.dragData = {
        dragging: true,
        x,
        y,
        originX: x,
        originY: y,
        lastX: x,
        lastY: y,
        offsetX,
        offsetY
      };
      this.setState({ dragging: true });
      if (this.props.onDragStart) {
        this.props.onDragStart(event, toDragData(this.dragData));
      }
      if (typeof this.props.children === "function") {
        this.forceUpdate();
      }
    };
    this.onPointerDown = (event) => {
      if (this.props.onPointerDown)
        this.props.onPointerDown(event);
      if (this.isDisabled())
        return;
      this.onDragStart(event);
    };
    this.onPointerMove = (event) => {
      if (this.props.onPointerMove)
        this.props.onPointerMove(event);
      this.onDrag(event);
    };
    this.onPointerUp = (event) => {
      if (this.props.onPointerUp)
        this.props.onPointerUp(event);
      this.onDragEnd(event);
    };
    this.setRef = (element) => {
      this.localRef.current = element;
      if (typeof this.props.innerRef === "function") {
        this.props.innerRef(element);
      } else if (this.props.innerRef) {
        this.props.innerRef.current = element;
      }
    };
    this.localRef = createRef();
    this.state = {
      dragging: false
    };
    if (props.throttle) {
      this.onDrag = throttle(this.onDrag, props.throttle);
      const { onDragEnd } = this;
      this.onDragEnd = (event) => {
        this.onDrag.flush();
        onDragEnd(event);
      };
    }
  }
  render() {
    const _a = this.props, {
      disabled,
      children,
      innerRef,
      tagName = "div"
    } = _a, props = __objRest(_a, [
      "disabled",
      "children",
      "innerRef",
      "tagName"
    ]);
    return React2.createElement(tagName, Object.assign({}, props, {
      onPointerDown: this.onPointerDown,
      onPointerMove: this.state.dragging ? this.onPointerMove : this.props.onPointerMove,
      onPointerUp: this.state.dragging ? this.onPointerUp : this.props.onPointerUp,
      ref: this.setRef
    }), typeof children === "function" ? children({
      dragData: toDragData(this.dragData)
    }) : children);
  }
};
var RefForwardedDraggable = React2.forwardRef((props, ref) => /* @__PURE__ */ React2.createElement(Draggable, __spreadProps(__spreadValues({}, props), {
  innerRef: ref
})));

// src/hooks/useKeyModifier.ts
import { useCallback, useEffect, useRef } from "react";
import { isMacOs } from "react-device-detect";
var ModifierKey = /* @__PURE__ */ ((ModifierKey2) => {
  ModifierKey2["Meta"] = "Meta";
  ModifierKey2["Control"] = "Control";
  ModifierKey2["Shift"] = "Shift";
  return ModifierKey2;
})(ModifierKey || {});
var SpecialModifierKey = /* @__PURE__ */ ((SpecialModifierKey2) => {
  SpecialModifierKey2["Space"] = " ";
  return SpecialModifierKey2;
})(SpecialModifierKey || {});
var DeviceCommandKey = isMacOs ? "Meta" /* Meta */ : "Control" /* Control */;
var modifierKeys = Object.values(ModifierKey);
function isModifierKey(key) {
  return modifierKeys.includes(key);
}
function useModifierKey(key, onChange, options = {}) {
  const isModifierActive = useCallback((event) => {
    if (key === null)
      return true;
    if (isModifierKey(key)) {
      return isKeyModifierOnEvent(event, key);
    }
    const hasMetaKey = event.shiftKey || event.ctrlKey || event.metaKey;
    return event.key.toLowerCase() === key.toLowerCase() && !hasMetaKey;
  }, [key]);
  useModifierKeyListener(isModifierActive, onChange, __spreadValues({
    disabled: key === null || options.disabled
  }, options));
}
function isKeyModifierOnEvent(event, modifierKey) {
  const eventKeys = {
    ["Control" /* Control */]: "ctrlKey",
    ["Meta" /* Meta */]: "metaKey",
    ["Shift" /* Shift */]: "shiftKey"
  };
  const isEventModKeySet = event[eventKeys[modifierKey]];
  return event.getModifierState(modifierKey) || !!isEventModKeySet;
}
function useModifierKeyListener(isModifierActive, onChange, options = {}) {
  const { disabled } = options;
  const keyDownHandled = useRef(false);
  const reset = useCallback((event) => {
    keyDownHandled.current = false;
    onChange(false, event);
  }, [onChange]);
  useEffect(() => {
    function onKeyDown(keyDownEvent) {
      function onKeyUp(keyUpEvent) {
        if (keyDownEvent.key === keyUpEvent.key) {
          resetAndRemoveListeners(keyUpEvent);
        }
      }
      function resetAndRemoveListeners(e) {
        reset(e);
        document.removeEventListener("keyup", onKeyUp);
      }
      if (!disabled && isModifierActive(keyDownEvent)) {
        if (!keyDownHandled.current) {
          document.addEventListener("keyup", onKeyUp);
          keyDownHandled.current = true;
        }
        onChange(true, keyDownEvent);
      }
    }
    if (!disabled) {
      document.addEventListener("keydown", onKeyDown);
    }
    return () => {
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [disabled, isModifierActive, onChange, reset]);
}

// src/hooks/useOnClickOutside.ts
import { useEffect as useEffect2 } from "react";
function useOnClickOutside(ref, handler) {
  useEffect2(() => {
    const listener = (event) => {
      if (!handler || !ref.current || event.target && ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener("pointerdown", listener);
    return () => {
      document.removeEventListener("pointerdown", listener);
    };
  }, [ref, handler]);
}

// src/hooks/useOverlayPortal.tsx
import React4, {
  createContext,
  useContext
} from "react";
import { createPortal } from "react-dom";
var OverlayPortalContext = createContext(void 0);
function OverlayPortalProvider({
  children,
  container
}) {
  return /* @__PURE__ */ React4.createElement(OverlayPortalContext.Provider, {
    value: container
  }, children);
}
function useOverlayPortal() {
  return useContext(OverlayPortalContext);
}
function OverlayPortal({ children }) {
  const overlayPortal = useOverlayPortal();
  if (overlayPortal === null)
    return null;
  if (overlayPortal === void 0)
    return /* @__PURE__ */ React4.createElement(React4.Fragment, null, "children");
  return createPortal(children, overlayPortal);
}

// src/hooks/useOnUnmount.ts
import { useEffect as useEffect3, useRef as useRef2 } from "react";
var useOnUnmount = (onUnmount) => {
  const callback = useRef2(onUnmount);
  callback.current = onUnmount;
  useEffect3(() => () => callback.current(), []);
};

// src/utils/replayEvents.ts
function getNextTargetElement(event) {
  return document.elementsFromPoint(event.clientX, event.clientY)[1];
}
function getTargetWithinShadowRoot(event, parentTarget) {
  let newTarget = parentTarget;
  if (!newTarget)
    return;
  while (newTarget.shadowRoot) {
    const shadowRoot = newTarget.shadowRoot;
    const elementAtPoint = shadowRoot.elementsFromPoint(event.clientX, event.clientY)[1];
    if (elementAtPoint && elementAtPoint !== newTarget) {
      newTarget = elementAtPoint;
    } else {
      break;
    }
  }
  return newTarget;
}
function replayEvents(event, eventToTrigger, { before, after } = {}) {
  event.preventDefault();
  event.nativeEvent.stopImmediatePropagation();
  event.nativeEvent.preventDefault();
  const { target } = event;
  const nextTarget = getNextTargetElement(event);
  if (nextTarget === target)
    return;
  const shadowRootTarget = getTargetWithinShadowRoot(event, nextTarget);
  if (!shadowRootTarget || shadowRootTarget === event.target)
    return;
  if (before)
    before(shadowRootTarget);
  shadowRootTarget.dispatchEvent(new MouseEvent(eventToTrigger, {
    bubbles: true,
    cancelable: true,
    composed: true,
    button: event.button,
    buttons: event.buttons,
    clientX: event.clientX,
    clientY: event.clientY
  }));
  if (after)
    after(shadowRootTarget);
}
export {
  DeviceCommandKey,
  RefForwardedDraggable as Draggable,
  DraggableCursor,
  ModifierKey,
  OverlayPortal,
  OverlayPortalContext,
  OverlayPortalProvider,
  SpecialModifierKey,
  getNextTargetElement,
  getTargetWithinShadowRoot,
  replayEvents,
  useModifierKey,
  useOnClickOutside,
  useOnUnmount,
  useOverlayPortal
};
